const TACTICS = [
  {
    icon: "ri-shield-star-line",
    tag: "身份冒认",
    title: "冒充客服主动联系",
    body: "以“账号异常”“系统升级”“发放补偿”为由主动加你，随后诱导你登录“官网”填写信息或开启远程协助，借机套取账户与支付权限。",
  },
  {
    icon: "ri-qr-code-line",
    tag: "钓鱼链接",
    title: "假链接 + 仿登录页",
    body: "把高仿登录页做成链接或二维码发给你，页面做得和官方几乎一致，一旦你登录，账号密码与验证码就同步进了骗子的后台。",
  },
  {
    icon: "ri-coupon-3-line",
    tag: "低价诱导",
    title: "限时活动与内部渠道",
    body: "用“内测名额”“老会员回流价”“扫码免单”制造稀缺感，先让你尝到甜头，再以“继续返现需充值”等话术持续套钱。",
  },
  {
    icon: "ri-computer-line",
    tag: "捆绑下载",
    title: "劫持与安装包陷阱",
    body: "通过弹窗或“网页版太卡”的借口让你下载破解包、绿色版，安装后可能被植入盗号木马，或在后台偷偷挖矿、弹广告、篡改首页。",
  },
  {
    icon: "ri-phone-lock-line",
    tag: "信息窃取",
    title: "以审核名义索取隐私",
    body: "声称要“实名审核”“解冻账户”，索要身份证、银行卡正面照与短信验证码。这些信息一旦泄露，极易被用于贷款、洗钱或盗刷。",
  },
  {
    icon: "ri-user-unfollow-line",
    tag: "镜像站",
    title: "域名高仿的镜像站",
    body: "完整复制官方页面做成镜像，只差一个字符的域名，专门拦截搜索引擎或输错网址的用户，用来投广告、诱导注册或传播恶意内容。",
  },
];

export default function Tactics() {
  return (
    <section id="tactics" className="scroll-mt-20">
      <div className="wrap py-10 md:py-14">
        <div className="flex flex-col justify-between gap-4 lg:flex-row lg:items-end">
          <div className="max-w-2xl">
            <p className="kicker mb-3">
              <i className="ri-spy-line"></i>
              套路拆解
            </p>
            <h2 className="font-heading text-2xl text-foreground-950 md:text-3xl">常见假冒与诈骗手法，提前认清</h2>
            <p className="mt-3 text-[15px] leading-7 text-foreground-700">
              假冒站点背后往往是成套的引流与诈骗链条。认清这些反复出现的套路，是识别吃瓜官网仿冒、守住钱包与账号的第一步。
            </p>
          </div>
          <a
            href="#checklist"
            className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2.5 text-sm font-semibold text-foreground-900 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            去做一份自查
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {TACTICS.map((t) => (
            <article key={t.title} className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5">
              <div className="flex items-center justify-between">
                <div className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-100 text-xl text-accent-700">
                  <i className={t.icon}></i>
                </div>
                <span className="rounded-full bg-primary-50 px-2.5 py-1 text-xs font-semibold text-primary-700 whitespace-nowrap">
                  {t.tag}
                </span>
              </div>
              <h3 className="mt-4 font-heading text-lg text-foreground-950">{t.title}</h3>
              <p className="mt-2 flex-1 text-sm leading-6 text-foreground-700">{t.body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}